/* eslint-disable */
import {put, takeEvery} from "redux-saga/effects";
import HomePageEvents from "./HomePageEvents";
import HomePageApi from "./HomePageApi";

import {RecommendVideo, userVideo, verticalList} from "./model/HomePage";
import {
    GetRecVideoListComplete,
    GetEditRecVideoListComplete,
    GetNewVideoList,
    GetNewVideoListComplete,
    GetRecommendProgramListComplete,
    GetRecommendProfessionalListComplete,
    AddVideoToRec,
    AddVideoToRecComplete,
    UpdateRecVideos,
    UpdateRecVideosComplete,
    UpdateRecVideosFailed,
    UpdateRecPrograms,
    UpdateRecProgramsComplete,
    UpdateRecProgramsFailed,
    UpdateRecProfessionals,
    UpdateRecProfessionalsComplete,
    UpdateRecProfessionalsFailed,
    GetVideoListByUserComplete,
    GetVideoListByUser,
    addRecProgram,
    addRecProgramComplete,
    delRecProgram,
    delRecProgramComplete,
    addRecProfessional,
    addRecProfessionalComplete,
    removeRecProfessional,
    removeRecProfessionalComplete,
    GetRecommendProgramList
} from "./HomePageActions";

// -----------------------------------------------------------------------------------
// おすすめビデオ
// 取得
function* GetRecommendVideo() {
    const videos: RecommendVideo[] = yield HomePageApi.GetRecommendVideoList();
    console.log("getRecommendVideoList", videos);
    yield put(GetRecVideoListComplete(videos));
}
// TODO
function* GetEditRecommendVideo() {
    const videos: RecommendVideo[] = yield HomePageApi.GetRecommendVideoList();
    console.log("getEditRecommendVideoList", videos);
    yield put(GetEditRecVideoListComplete(videos));
}
// 編集（削除を含め）
function* UpdateRecVideoList({videos}: ReturnType<typeof UpdateRecVideos>) {
    const response: any = yield HomePageApi.UpdateRecVideos(videos);
    if(response.response && response.response.status !== 200){
        yield put(UpdateRecVideosFailed());
        console.log("UpdateRecVideosFailed");
   }else{
        yield put(UpdateRecVideosComplete(response));
        console.log("UpdateRecVideosComplete");
        console.log("recommendvideos", response);
   }
}
// 追加
function* AddVideoToRecWorker({videoId}: ReturnType<typeof AddVideoToRec>) {
    const recommendVideoList: RecommendVideo[] = yield HomePageApi.AddVideoToRec(videoId);
    console.log("addVideoToRecommend", recommendVideoList);
    yield put(AddVideoToRecComplete(recommendVideoList));
}

// -----------------------------------------------------------------------------------
// おすすめプログラム
// 取得
function* GetRecommendPrograms({userId}: ReturnType<typeof GetRecommendProgramList>){
    const recommendProgramList: verticalList[] = yield HomePageApi.GetRecommendProgramList(userId);
    console.log("GetRecommendProgramList", recommendProgramList);
    yield put(GetRecommendProgramListComplete(recommendProgramList));
}
// 編集
function* UpdateRecProgramList({programs,userId}: ReturnType<typeof UpdateRecPrograms>) {
    const response: any = yield HomePageApi.UpdateRecPrograms(programs,userId);
    if(response.response && response.response.status !== 200){
        yield put(UpdateRecProgramsFailed());
        console.log("UpdateRecProgramsFailed");
   }else{
        yield put(UpdateRecProgramsComplete(response));
        console.log("UpdateRecProgramsComplete");
        console.log("recommendprograms", response);
   }
}
// 追加
function* addRecProgramWorker({id,userId}: ReturnType<typeof addRecProgram>) {
    const response: any = yield HomePageApi.addRecProgram(id,userId);
    console.log("HomePageSaga: addRecProgramWorker:", response)
    yield put(addRecProgramComplete(response));
}
// 削除
function* delRecProgramWorker({id,userId}: ReturnType<typeof delRecProgram>) {
    const response: any = yield HomePageApi.delRecProgram(id,userId);
    console.log("HomePageSaga: delRecProgramWorker:", response)
    yield put(delRecProgramComplete(response));
}

// -----------------------------------------------------------------------------------
// おすすめプロフェショナル
// 取得
function* GetRecommendProfessionalList() {
    const recommendProfessionalList: verticalList[] = yield HomePageApi.GetRecommendProfessionalList();
    console.log("GetRecommendProfessionalList", recommendProfessionalList);
    yield put(GetRecommendProfessionalListComplete(recommendProfessionalList));
}
// 編集
function* UpdateRecProfessionalList({professionals}: ReturnType<typeof UpdateRecProfessionals>) {
    const response: any = yield HomePageApi.UpdateRecProfessionals(professionals);
    if(response.response && response.response.status !== 200){
        yield put(UpdateRecProfessionalsFailed());
        console.log("UpdateRecProfessionalsFailed");
   }else{
        yield put(UpdateRecProfessionalsComplete(response));
        console.log("UpdateRecProfessionalsComplete");
        console.log("recommendProfessionals", response);
   }
}
// 追加
function* addRecProfessionalWorker({id}: ReturnType<typeof addRecProfessional>) {
    const recommendProfessionalList: verticalList[] = yield HomePageApi.addRecProfessional(id);
    console.log("Saga: addRecProfessionalWorker:",recommendProfessionalList)
    yield put(addRecProfessionalComplete(recommendProfessionalList));
}
// 削除
function* removeRecProfessionalWorker({id}: ReturnType<typeof removeRecProfessional>) {
    const recommendProfessionalList: verticalList[] = yield HomePageApi.removeRecProfessional(id);
    console.log("Saga: removeRecProfessionalWorker:",recommendProfessionalList)
    yield put(removeRecProfessionalComplete(recommendProfessionalList));
}
// -----------------------------------------------------------------------------------
// 新着ビデオ
// 取得
function* GetNewVideos({userId}: ReturnType<typeof GetNewVideoList>) {
    const newVideoList: verticalList[] = yield HomePageApi.GetNewVideoList(userId);
    console.log("GetNewVideoList", newVideoList);
    yield put(GetNewVideoListComplete(newVideoList));
}

// -----------------------------------------------------------------------------------
// ユーザー視聴履歴
function* GetVideoList({userId}: ReturnType<typeof GetVideoListByUser>) {
    const videoList: userVideo[] = yield HomePageApi.GetVideosByUser(userId);
    console.log("GetUserVideos : ", videoList)
    yield put(GetVideoListByUserComplete(videoList));
}

export default function* HomePageSaga() {
    yield takeEvery(HomePageEvents.GetRecVideoListStarted, GetRecommendVideo);
    yield takeEvery(HomePageEvents.GetEditRecVideoListStarted, GetEditRecommendVideo);
    yield takeEvery(HomePageEvents.addRecProgramStarted, addRecProgramWorker);
    yield takeEvery(HomePageEvents.delRecProgramStarted, delRecProgramWorker);
    yield takeEvery(HomePageEvents.GetNewVideoListStarted, GetNewVideos);
    yield takeEvery(HomePageEvents.GetRecommendProgramListStarted, GetRecommendPrograms);
    yield takeEvery(HomePageEvents.GetRecommendProfessionalListStarted, GetRecommendProfessionalList);
    yield takeEvery(HomePageEvents.AddVideoToRecStarted, AddVideoToRecWorker);
    yield takeEvery(HomePageEvents.UpdateRecVideosStarted, UpdateRecVideoList);
    yield takeEvery(HomePageEvents.UpdateRecProgramsStarted, UpdateRecProgramList);
    yield takeEvery(HomePageEvents.UpdateRecProfessionalsStarted, UpdateRecProfessionalList);
    yield takeEvery(HomePageEvents.GetVideoListByUserStarted, GetVideoList);
    yield takeEvery(HomePageEvents.addRecProfessionalStarted, addRecProfessionalWorker);
    yield takeEvery(HomePageEvents.removeRecProfessionalStarted, removeRecProfessionalWorker);
}
